import React, { useEffect, useState } from "react";
import "./main_sidebar.css";
import Accordion from "react-bootstrap/Accordion";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "../../utils/IDS";
import { Allpermissions, isTokenValid } from "../../features/auth/Slice";

const Sidebar = ({ closeSidebar }) => {
  // Get the current location
  const dispatch = useDispatch();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;
  const Permission = useSelector((state) => state.auth?.admin_info);

  useEffect(() => {
    dispatch(Allpermissions());
  }, [dispatch]);

  const getActiveAccordionKey = () => {
    const path = location.pathname;

    const dashboardPaths = ["/"];

    const masterPaths = [
      "/country-table",
      "/state-table",
      "/city-table",
      "/pincode-table",
      "/vehicle-category",
      "/vehicle",
      "/banner",
      "/save_location",
      "/good_type",
      "/faq",
      "/trainingvideos",
      "/driverbanner",
    ];

    const aboutPaths = ["/aboutus", "/keyfeature", "/whychooseus"];

    const contentPaths = [
      "/privacypolicy",
      "/driverprivacypolicy",
      "/cutomer-booking-tnc",
      "/customer-terms-and-condition",
      "/driver-terms-and-condition",
    ];

    const customizationPaths = ["/appsetup"];

    const formPaths = ["/contactus", "/enquiry"];

    const customerMgmtPaths = ["/customer", "/driver"];

    const bookingPaths = ["/booking"];

    const walletPaths = [
      "/withdraw-request",
      "/wallet-history",
      "/wallet-fund-add-request",
    ];

    if (dashboardPaths.includes(path)) return "1";
    if (masterPaths.includes(path)) return "11";
    if (aboutPaths.includes(path)) return "7";
    if (contentPaths.includes(path)) return "9";
    if (customizationPaths.includes(path)) return "10";
    if (formPaths.includes(path)) return "12";
    if (customerMgmtPaths.includes(path)) return "13";
    if (bookingPaths.includes(path)) return "14";
    if (walletPaths.includes(path)) return "15";
  };

  return (
    <>
      <section className="sidebar_main theme_bg">
        {/* <div className="logo_sec">
          <h3 className="hometitle">
            <Link to="/">
              <FontAwesomeIcon icon={faHouse} /> Home
            </Link>
          </h3>
        </div> */}

        <div className="sidebar_list">
          <Accordion defaultActiveKey={getActiveAccordionKey()} flush>
            <Accordion.Item eventKey="1">
              <Link to="/" onClick={closeSidebar}>
                <Accordion.Header
                  className={` ${isActive("/") ? "active" : ""}`}
                >
                  Dashboard
                </Accordion.Header>
              </Link>
            </Accordion.Item>
            {Permission?.includes(IDS.Permission.Country.List) ||
            Permission?.includes(IDS.Permission.State.List) ||
            Permission?.includes(IDS.Permission.City.List) ||
            Permission?.includes(IDS.Permission.Pincode.List) ||
            Permission?.includes(IDS.Permission.Banner.List) ||
            Permission?.includes(IDS.Permission.Save_Location.List) ||
            Permission?.includes(IDS.Permission.Good_Type.List) ||
            Permission?.includes(IDS.Permission.Faq.List) ||
            Permission?.includes(IDS.Permission.Training_Video.List) ||
            Permission?.includes(IDS.Permission.Driver_Banner.List) ? (
              <Accordion.Item eventKey="11">
                <Accordion.Header>Master</Accordion.Header>
                <Accordion.Body>
                  <div className="acc_inner_menu">
                    {Permission?.includes(IDS.Permission.Country.List) ||
                    Permission?.includes(IDS.Permission.Country.Add) ||
                    Permission?.includes(IDS.Permission.Country.Edit) ||
                    Permission?.includes(IDS.Permission.Country.Delete) ? (
                      <Link to="/country-table" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/country-table") ? "active" : ""
                          }`}
                        >
                          Country
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.State.List) ||
                    Permission?.includes(IDS.Permission.State.Add) ||
                    Permission?.includes(IDS.Permission.State.Edit) ||
                    Permission?.includes(IDS.Permission.State.Delete) ? (
                      <Link to="/state-table" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/state-table") ? "active" : ""
                          }`}
                        >
                          State
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.City.List) ||
                    Permission?.includes(IDS.Permission.City.Add) ||
                    Permission?.includes(IDS.Permission.City.Edit) ||
                    Permission?.includes(IDS.Permission.City.Delete) ? (
                      <Link to="/city-table" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/city-table") ? "active" : ""
                          }`}
                        >
                          City
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Pincode.List) ||
                    Permission?.includes(IDS.Permission.Pincode.Add) ||
                    Permission?.includes(IDS.Permission.Pincode.Edit) ||
                    Permission?.includes(IDS.Permission.Pincode.Delete) ? (
                      <Link to="/pincode-table" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/pincode-table") ? "active" : ""
                          }`}
                        >
                          Pincode
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(
                      IDS.Permission.Vehicle_Category.List
                    ) ||
                    Permission?.includes(IDS.Permission.Vehicle_Category.Add) ||
                    Permission?.includes(
                      IDS.Permission.Vehicle_Category.Edit
                    ) ||
                    Permission?.includes(
                      IDS.Permission.Vehicle_Category.Delete
                    ) ? (
                      <Link to="/vehicle-category" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/vehicle-category") ? "active" : ""
                          }`}
                        >
                          Vehicle Category
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(
                      IDS.Permission.Vehicle_Category.List
                    ) ||
                    Permission?.includes(IDS.Permission.Vehicle_Category.Add) ||
                    Permission?.includes(
                      IDS.Permission.Vehicle_Category.Edit
                    ) ||
                    Permission?.includes(
                      IDS.Permission.Vehicle_Category.Delete
                    ) ? (
                      <Link to="/vehicle" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/vehicle") ? "active" : ""
                          }`}
                        >
                          Vehicle
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Banner.List) ||
                    Permission?.includes(IDS.Permission.Banner.Add) ||
                    Permission?.includes(IDS.Permission.Banner.Edit) ||
                    Permission?.includes(IDS.Permission.Banner.Delete) ? (
                      <Link to="/banner" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/banner") ? "active" : ""
                          }`}
                        >
                          Customer Banner
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {/* {Permission?.includes(IDS.Permission.Save_Location.List) ||
                    Permission?.includes(IDS.Permission.Save_Location.Add) ||
                    Permission?.includes(IDS.Permission.Save_Location.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Save_Location.Delete
                    ) ? (
                      <Link to="/save_location" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/save_location") ? "active" : ""
                          }`}
                        >
                          Save Location
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )} */}

                    {Permission?.includes(IDS.Permission.Good_Type.List) ||
                    Permission?.includes(IDS.Permission.Good_Type.Add) ||
                    Permission?.includes(IDS.Permission.Good_Type.Edit) ||
                    Permission?.includes(IDS.Permission.Good_Type.Delete) ? (
                      <Link to="/good_type" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/good_type") ? "active" : ""
                          }`}
                        >
                          Good Type
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Faq.List) ||
                    Permission?.includes(IDS.Permission.Faq.Add) ||
                    Permission?.includes(IDS.Permission.Faq.Edit) ||
                    Permission?.includes(IDS.Permission.Faq.Delete) ? (
                      <Link to="/faq" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/faq") ? "active" : ""
                          }`}
                        >
                          FAQ
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Training_Video.List) ||
                    Permission?.includes(IDS.Permission.Training_Video.Add) ||
                    Permission?.includes(IDS.Permission.Training_Video.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Training_Video.Delete
                    ) ? (
                      <Link to="/trainingvideos" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/trainingvideos") ? "active" : ""
                          }`}
                        >
                          Training Video
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}

                    {Permission?.includes(IDS.Permission.Driver_Banner.List) ||
                    Permission?.includes(IDS.Permission.Driver_Banner.Add) ||
                    Permission?.includes(IDS.Permission.Driver_Banner.Edit) ||
                    Permission?.includes(
                      IDS.Permission.Driver_Banner.Delete
                    ) ? (
                      <Link to="/driverbanner" onClick={closeSidebar}>
                        <div
                          className={`menu_div ${
                            isActive("/driverbanner") ? "active" : ""
                          }`}
                        >
                          Driver Banner
                        </div>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <></>
            )}
            <Accordion.Item eventKey="22">
              <Accordion.Header>Coupons Management</Accordion.Header>
              <Accordion.Body>
                <div className="acc_inner_menu">
                  <Link to="/coupon" onClick={closeSidebar}>
                    <div
                      className={`menu_div ${
                        isActive("/coupon") ? "active" : ""
                      }`}
                    >
                      Coupons
                    </div>
                  </Link>
                  <Link to="/coupon-history" onClick={closeSidebar}>
                    <div
                      className={`menu_div ${
                        isActive("/coupon-history") ? "active" : ""
                      }`}
                    >
                      Coupons History
                    </div>
                  </Link>

                
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="20">
              <Accordion.Header>Broadcast Notifications</Accordion.Header>
              <Accordion.Body>
                <div className="acc_inner_menu">
                  <Link to="/broadcast-send" onClick={closeSidebar}>
                    <div
                      className={`menu_div ${
                        isActive("/broadcast-send") ? "active" : ""
                      }`}
                    >
                      Broadcast
                    </div>
                  </Link>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="21">
              <Link to="/document-require" onClick={closeSidebar}>
                <Accordion.Header>Document Requirements</Accordion.Header>
              </Link>
            </Accordion.Item>
            <Accordion.Item eventKey="7">
              <Accordion.Header>About</Accordion.Header>
              <Accordion.Body>
                <div className="acc_inner_menu">
                  {Permission?.includes(IDS.Permission.About_Us.List) ||
                  Permission?.includes(IDS.Permission.About_Us.Add) ||
                  Permission?.includes(IDS.Permission.About_Us.Edit) ||
                  Permission?.includes(IDS.Permission.About_Us.Delete) ? (
                    <Link to="/aboutus" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/aboutus") ? "active" : ""
                        }`}
                      >
                        About Us
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}

                  {/* {Permission?.includes(IDS.Permission.Key_Feature.List) ||
                  Permission?.includes(IDS.Permission.Key_Feature.Add) ||
                  Permission?.includes(IDS.Permission.Key_Feature.Edit) ||
                  Permission?.includes(IDS.Permission.Key_Feature.Delete) ? (
                    <Link to="/keyfeature" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/keyfeature") ? "active" : ""
                        }`}
                      >
                        Key Features
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )} */}

                  {/* {Permission?.includes(IDS.Permission.Why_Choose_Us.List) ||
                  Permission?.includes(IDS.Permission.Why_Choose_Us.Add) ||
                  Permission?.includes(IDS.Permission.Why_Choose_Us.Edit) ||
                  Permission?.includes(IDS.Permission.Why_Choose_Us.Delete) ? (
                    <Link to="/whychooseus" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/whychooseus") ? "active" : ""
                        }`}
                      >
                        Why Choose Us
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )} */}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="9">
              <Accordion.Header>Content</Accordion.Header>
              <Accordion.Body>
                <div className="acc_inner_menu">
                  {Permission?.includes(IDS.Permission.Term_Condition.List) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Add) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Edit) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Delete) ? (
                    <Link to="/termconditions">
                      <div
                        className={`menu_div ${
                          isActive("/termconditions") ? "active" : ""
                        }`}
                      >
                        Customer Terms Conditions
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}
                  {Permission?.includes(IDS.Permission.Privacy_Policy.List) ||
                  Permission?.includes(IDS.Permission.Privacy_Policy.Add) ||
                  Permission?.includes(IDS.Permission.Privacy_Policy.Edit) ||
                  Permission?.includes(IDS.Permission.Privacy_Policy.Delete) ? (
                    <Link to="/privacypolicy" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/privacypolicy") ? "active" : ""
                        }`}
                      >
                        Customer Privacy Policy
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}

                  {Permission?.includes(IDS.Permission.Privacy_Policy.List) ||
                  Permission?.includes(IDS.Permission.Privacy_Policy.Add) ||
                  Permission?.includes(IDS.Permission.Privacy_Policy.Edit) ||
                  Permission?.includes(IDS.Permission.Privacy_Policy.Delete) ? (
                    <Link to="/driverprivacypolicy" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/driverprivacypolicy") ? "active" : ""
                        }`}
                      >
                        Driver Privacy Policy
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}

                  {Permission?.includes(IDS.Permission.Term_Condition.List) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Add) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Edit) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Delete) ? (
                    <Link to="/cutomer-booking-tnc" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/cutomer-booking-tnc") ? "active" : ""
                        }`}
                      >
                        Booking Terms and Conditions
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}

                  {/* {Permission?.includes(IDS.Permission.Term_Condition.List) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Add) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Edit) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Delete) ? (
                    <Link to="/customer-terms-and-condition">
                      <div
                        className={`menu_div ${
                          isActive("/customer-terms-and-condition")
                            ? "active"
                            : ""
                        }`}
                      >
                        Customer Terms and Conditions
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )} */}

                  {Permission?.includes(IDS.Permission.Term_Condition.List) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Add) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Edit) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Delete) ? (
                    <Link
                      to="/driver-terms-and-condition"
                      onClick={closeSidebar}
                    >
                      <div
                        className={`menu_div ${
                          isActive("/driver-terms-and-condition")
                            ? "active"
                            : ""
                        }`}
                      >
                        Driver Terms and Conditions
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}

                  {Permission?.includes(IDS.Permission.Term_Condition.List) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Add) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Edit) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Delete) ? (
                    <Link to="/shippingridepolicy">
                      <div
                        className={`menu_div ${
                          isActive("/shippingridepolicy") ? "active" : ""
                        }`}
                      >
                        Shipping Ride Policy
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}

                  {Permission?.includes(IDS.Permission.Term_Condition.List) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Add) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Edit) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Delete) ? (
                    <Link to="/cancellationpolicy">
                      <div
                        className={`menu_div ${
                          isActive("/cancellationpolicy") ? "active" : ""
                        }`}
                      >
                        Cancellation Policy
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}

                  {Permission?.includes(IDS.Permission.Term_Condition.List) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Add) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Edit) ||
                  Permission?.includes(IDS.Permission.Term_Condition.Delete) ? (
                    <Link to="/refundpolicy">
                      <div
                        className={`menu_div ${
                          isActive("/refundpolicy") ? "active" : ""
                        }`}
                      >
                        Refund Policy
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}

                   {Permission?.includes(IDS.Permission.Booking_Cancel_Reason.List) ||
                  Permission?.includes(IDS.Permission.Booking_Cancel_Reason.Add) ||
                  Permission?.includes(IDS.Permission.Booking_Cancel_Reason.Edit) ||
                  Permission?.includes(IDS.Permission.Booking_Cancel_Reason.Delete) ? (
                    <Link to="/bookingcancelreason">
                      <div
                        className={`menu_div ${
                          isActive("/bookingcancelreason") ? "active" : ""
                        }`}
                      >
                        Booking Cancel Reason
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="10">
              <Accordion.Header>Customizaton</Accordion.Header>
              <Accordion.Body>
                <div className="acc_inner_menu">
                  {Permission?.includes(IDS.Permission.App_Setup.List) ||
                  Permission?.includes(IDS.Permission.App_Setup.Edit) ? (
                    <Link to="/appsetup" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/appsetup") ? "active" : ""
                        }`}
                      >
                        App Setup
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}
                  {Permission?.includes(IDS.Permission.App_Setup.List) ||
                  Permission?.includes(IDS.Permission.App_Setup.Edit) ? (
                    <Link to="/cabappsetup" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/cabappsetup") ? "active" : ""
                        }`}
                      >
                        Cab Setup
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}
                  {Permission?.includes(IDS.Permission.App_Setup.List) ||
                  Permission?.includes(IDS.Permission.App_Setup.Edit) ? (
                    <Link to="/transportappsetup" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/transportappsetup") ? "active" : ""
                        }`}
                      >
                        Transport Setup
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="12">
              <Accordion.Header>Form</Accordion.Header>
              <Accordion.Body>
                <div className="acc_inner_menu">
                  {Permission?.includes(IDS.Permission.Contact.List) ? (
                    <Link to="/contactus" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/contactus") ? "active" : ""
                        }`}
                      >
                        Contact Us
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}

                  {Permission?.includes(IDS.Permission.Enquiry.List) ? (
                    <Link to="/enquiry" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/enquiry") ? "active" : ""
                        }`}
                      >
                        Enquiry
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="23">
              <Accordion.Header>User Management</Accordion.Header>
              <Accordion.Body>
                <div className="acc_inner_menu">
                  {Permission?.includes(IDS.Permission.Users.List) ? (
                    <Link to="/users" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/users") ? "active" : ""
                        }`}
                      >
                        Users
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}

                  {Permission?.includes(IDS.Permission.Roles.List) ? (
                    <Link to="/roles" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/roles") ? "active" : ""
                        }`}
                      >
                        Roles
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="13">
              <Accordion.Header>Customer Management</Accordion.Header>
              <Accordion.Body>
                <div className="acc_inner_menu">
                  {Permission?.includes(IDS.Permission.Customer.List) ? (
                    <Link to="/customer" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/customer") ? "active" : ""
                        }`}
                      >
                        Customer
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}

                  {Permission?.includes(IDS.Permission.Driver.List) ||
                  Permission?.includes(IDS.Permission.Driver.Edit) ? (
                    <Link to="/driver" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/driver") ? "active" : ""
                        }`}
                      >
                        Driver
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="19">
              <Link to="/sos-request" onClick={closeSidebar}>
                <Accordion.Header>SOS Requests</Accordion.Header>
              </Link>
            </Accordion.Item>{" "}
            <Accordion.Item eventKey="14">
              <Accordion.Header>Transport Booking</Accordion.Header>
              <Accordion.Body>
                <div className="acc_inner_menu">
                  {Permission?.includes(IDS.Permission.Customer.List) ? (
                    <Link to="/booking" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/booking") ? "active" : ""
                        }`}
                      >
                        Booking
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>{" "}
            <Accordion.Item eventKey="18">
              <Accordion.Header>Cab Booking</Accordion.Header>
              <Accordion.Body>
                <div className="acc_inner_menu">
                  {Permission?.includes(IDS.Permission.Customer.List) ? (
                    <Link to="/cab-booking" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/cab-booking") ? "active" : ""
                        }`}
                      >
                        Booking
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>{" "}
            <Accordion.Item eventKey="15">
              <Accordion.Header>Wallet Management</Accordion.Header>
              <Accordion.Body>
                <div className="acc_inner_menu">
                  {Permission?.includes(IDS.Permission.Customer.List) ? (
                    <Link to="/withdraw-request" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/withdraw-request") ? "active" : ""
                        }`}
                      >
                        Withdraw Request
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}{" "}
                  {Permission?.includes(IDS.Permission.Customer.List) ? (
                    <Link to="/wallet-history" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/wallet-history") ? "active" : ""
                        }`}
                      >
                        Wallet History
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}
                  {/* {Permission?.includes(IDS.Permission.Customer.List) ? (
                    <Link to="/wallet-fund-add-request" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/wallet-fund-add-request") ? "active" : ""
                        }`}
                      >
                        Fund add Request
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}{" "} */}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            {/* <Accordion.Item eventKey="17">
              <Accordion.Header>Customer Wallet</Accordion.Header>
              <Accordion.Body>
                <div className="acc_inner_menu">
                  {Permission?.includes(IDS.Permission.Customer.List) ? (
                    <Link
                      to="/customer-withdraw-request"
                      onClick={closeSidebar}
                    >
                      <div
                        className={`menu_div ${
                          isActive("/customer-withdraw-request") ? "active" : ""
                        }`}
                      >
                        Withdraw Request
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}{" "}
                  {Permission?.includes(IDS.Permission.Customer.List) ? (
                    <Link to="/customer-wallet-history" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/customer-wallet-history") ? "active" : ""
                        }`}
                      >
                        Wallet History
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item> */}
            <Accordion.Item eventKey="16">
              <Accordion.Header>Heat Map</Accordion.Header>
              <Accordion.Body>
                <div className="acc_inner_menu">
                  {Permission?.includes(IDS.Permission.Customer.List) ? (
                    <Link to="/heat-map" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/heat-map") ? "active" : ""
                        }`}
                      >
                        Transport Heat Map
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}
                  {Permission?.includes(IDS.Permission.Customer.List) ? (
                    <Link to="/heat-map-cab" onClick={closeSidebar}>
                      <div
                        className={`menu_div ${
                          isActive("/heat-map-cab") ? "active" : ""
                        }`}
                      >
                        Cab Heat Map
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}{" "}
                </div>{" "}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </section>
    </>
  );
};

export default Sidebar;
